import {createBrowserRouter} from "react-router-dom";
import Error404Screen from "../views/Error404Screen";
import RootWrapper from "../views/RootWrapper";
import TaskScreen from "../views/TaskScreen";
import ReferralScreen from "../views/ReferralScreen";
import CodesScreen from "../views/CodesScreen";
import MainScreen from "../views/MainScreen";
import Error401Screen from "../views/Error401Screen";
import RootSplashScreen from "../views/RootSplashScreen";
import TutorialSplashScreen from "../views/tutorial/TutorialSplashScreen";
import TutorialMainScreen from "../views/tutorial/TutorialMainScreen";
import TutorialCodesScreen from "../views/tutorial/TutorialCodesScreen";

 const router = createBrowserRouter([
     {
         path: "/",
         element: <RootSplashScreen/>,
         errorElement: <Error404Screen />,
     },
     {
         path: "/",
         element: <RootWrapper/>,
         errorElement: <Error404Screen />,
         children: [
             {
                 path: "main",
                 element: <MainScreen />,
             },
             {
                 path: "tasks",
                 element: <TaskScreen />,
             },
             {
                 path: "referral",
                 element: <ReferralScreen />,
             },
             {
                 path: "codes",
                 element: <CodesScreen />,
             },
         ],
     },
     {
         path: "/tutorial",
         element: <TutorialSplashScreen/>,
         errorElement: <Error404Screen />,
     },
     {
         path: "/tutorial",
         element: <RootWrapper/>,
         errorElement: <Error404Screen />,
         children: [
             {
                 path: "main",
                 element: <TutorialMainScreen />,
             },
             {
                 path: "tasks",
                 element: <TaskScreen />,
             },
             {
                 path: "referral",
                 element: <ReferralScreen />,
             },
             {
                 path: "codes",
                 element: <TutorialCodesScreen />,
             },
         ],
     },
     {
         path: "/unauthorized",
         element: <Error401Screen/>,
         errorElement: <Error404Screen />,
     },
]);

 export default router;
